import { Field } from 'formik';
import ValidationError from 'gcs-common/components/Formik/ValidationError/ValidationError';
import type { ReactNode } from 'react';
import styles from './styles.module.scss';

export type FormikInputProps = Record<string, unknown> & {
  children?: ReactNode;
  disableHoverOver?: boolean;
  disabled?: boolean;
  errorClassName?: string;
  label?: string;
  name?: string;
  placeholder?: string;
  textClassName?: string;
  type?: string;
};

const FormikInput = ({
  textClassName,
  errorClassName,
  label = '',
  disabled = false,
  name = '',
  type = 'text',
  placeholder = '',
  disableHoverOver = false,
  children,
  ...props
}: FormikInputProps) => {
  return (
    <div className={styles.formikInputContainer}>
      <div className={`${styles.formikInputWrapper} ${disabled || disableHoverOver ? styles.disabled : ''}`}>
        {label && (
          <label className={styles.formikInputLabel} htmlFor={name}>
            {label}
          </label>
        )}
        {children}
        <Field
          id={name}
          className={textClassName || styles.formikInput}
          placeholder={placeholder}
          type={type}
          name={name}
          disabled={disabled}
          {...props}
        />
      </div>
      <div className={errorClassName || ''}>
        <ValidationError name={name} />
      </div>
    </div>
  );
};

export default FormikInput;
